import Vue from "vue";
import Vuex from "vuex";
import { GetVersionInformation } from "@/services/contract.service.js";
import { GetConfiguration } from "@/services/minimum.wage.services/configuration.minimum.wages.js";
import { GetAllVariables } from "@/services/minimum.wage.services/variables.minimum.wages.js";
import { GetGroupings } from "@/services/minimum.wage.services/groupings.minimum.wages.js";
import { GetCriteria } from "@/services/minimum.wage.services/criteria.minimum.wages.js";
import { GetStructure } from "@/services/minimum.wage.services/structure.minimum.wages.js";
import { GetAllTemplates } from "@/services/minimum.wage.services/template.minimum.wages.js";
import { GetAvailableTenants } from "@/services/contract.tenants.service.js";
import { GetAllCities } from "@/services/cantons.service.js";
import { HistoryHelper } from "@/helpers/HistoryHelper";
import { GetCitiesVNext } from "@/services/contract.edition.cantons.service.js";
import { GetSinlgeEdition } from "@/services/contract.edition.service";

Vue.use(Vuex);

function getFlatStructure(structure) {
  var result = [];

  structure.map((node) => {
    var nodeCopy = JSON.parse(JSON.stringify(node));
    // delete nodeCopy.children;
    result.push(nodeCopy);

    if (node.children) {
      var childNodes = getFlatStructure(node.children);
      childNodes.map((childNode) => {
        result.push(childNode);
      });
    }
  });

  return result;
}

export default new Vuex.Store({
  state: {
    loadingActionsCount: 0,
    contractConfiguration: {
      canUserEdit: null,
    },
    mindestLohnKonfiguration: {
      BasicContractInformation: {
        contractName: null,
        contractNumber: null,
        contractVersion: null,
        contractEdition: null,
        translatedLanguages: null,
      },
      Configuration: {},
      Cantons: [],
      ValidEditionLocations: [],
      Structure: [],
      StructureFlat: [],
      Criteria: [],
      Groupings: [],
      Variables: [],
      States: [],
      AggregatedStates: [],
      Cities: [],
      Templates: [],
      Tenants: [],
      isLoading: [],
    },
    adminCurrentContract: {
      ShortName: "",
      Version: "",
      VersionId: "",
      ContractNumber: "",
      Editions: [],
      VersionData: null,
      TranslatedLanguages: [],
      ContractLanguage: "de-CH",
    },
    errorObjects: {
      Structure: null,
      Criteria: null,
      Variables: null,
      Groupings: null,
      Configuration: null,
      VersionInformation: null,
      GetAllContractVersions: null,
    },
    history: {
      mindestLohnKonfiguration: {
        ruleConfiguration: {
          groupedRulesConfig: new HistoryHelper(),
          ungroupedRuleConfig: new HistoryHelper(),
          shouldUpdateListitemHistory: false,
          shouldUpdateGroupHistory: false,
        },
      },
    },

    contractsToCompare: [],
  },
  getters: {
    structure: (state) => state.mindestLohnKonfiguration.Structure,
    structureFlat: (state) => state.mindestLohnKonfiguration.StructureFlat,
    variables: (state) => state.mindestLohnKonfiguration.Variables,
    loadingCount: (state) => state.mindestLohnKonfiguration.isLoading.length,
    isVersionInformationLoading: (state) =>
      state.mindestLohnKonfiguration.isLoading.includes("VersionInformation"),
    isMLConfigurationLoading: (state) =>
      state.mindestLohnKonfiguration.isLoading.includes("Configuration"),
    isInputGroupingsLoading: (state) =>
      state.mindestLohnKonfiguration.isLoading.includes("Groupings"),
    isCriteriaLoading: (state) =>
      state.mindestLohnKonfiguration.isLoading.includes("Criteria"),
    isVariablesLoading: (state) =>
      state.mindestLohnKonfiguration.isLoading.includes("Variables"),
    isStructureLoading: (state) =>
      state.mindestLohnKonfiguration.isLoading.includes("Structure"),
    getTemplatesByType: (state) => (type) =>
      state.mindestLohnKonfiguration.Templates.filter((template) => {
        return template.type === type;
      }),
  },
  actions: {
    getAllTemplates({ commit }, payload) {
      commit("setLoading", "Templates");
      commit("setErrorObject", {
        name: "Templates",
        errorObject: null,
      });

      GetAllTemplates(
        payload.contractId,
        payload.versionId,
        payload.editionId,
        (response) => {
          commit("setTemplates", JSON.parse(JSON.stringify(response)));
          commit("unsetLoading", "Templates");
        },
        (error) => {
          this.errorObject = error;
          commit("unsetLoading", "Templates");
          commit("setErrorObject", {
            name: "Templates",
            errorObject: error,
          });
        },
      );
    },
    getAllTenants({ commit }) {
      commit("setLoading", "Tenants");
      commit("setErrorObject", {
        name: "Tenants",
        errorObject: null,
      });

      GetAvailableTenants(
        (response) => {
          commit("setTenants", JSON.parse(JSON.stringify(response)));
          commit("unsetLoading", "Tenants");
        },
        (error) => {
          this.errorObject = error;
          commit("unsetLoading", "Tenants");
          commit("setErrorObject", {
            name: "Tenants",
            errorObject: error,
          });
        },
      );
    },
    getVersionInformation({ commit }, payload) {
      commit("setLoading", "VersionInformation");
      commit("setErrorObject", {
        name: "VersionInformation",
        errorObject: null,
      });

      GetVersionInformation(
        payload.contractId,
        payload.versionId,
        (result) => {
          var versionTitle = result.versionContents.filter(function (item) {
            return item.language == "de-CH";
          });

          if (versionTitle.length == 1) {
            commit("setBasicContractInformation", {
              contractName: versionTitle[0].value,
              contractNumber: payload.contractId,
              contractVersion: payload.versionId,
              contractEdition: this.editionId,
              translatedLanguages:
                result.translatedToLanguages.length == 0
                  ? [
                      {
                        language: "de-CH",
                        name: "Deutsch",
                      },
                    ]
                  : result.translatedToLanguages,
            });
          } else if (result.versionContents.length > 0) {
            commit("setBasicContractInformation", {
              contractName: result.versionContents[0].value,
              contractNumber: payload.contractId,
              contractVersion: payload.versionId,
              contractEdition: this.editionId,
              translatedLanguages:
                result.translatedToLanguages.length == 0
                  ? [
                      {
                        language: "de-CH",
                        name: "Deutsch",
                      },
                    ]
                  : result.translatedToLanguages,
            });
          }

          commit("unsetLoading", "VersionInformation");
        },
        (error) => {
          commit("setLoading", "VersionInformation");
          commit("setErrorObject", {
            name: "VersionInformation",
            errorObject: error,
          });
        },
      );
    },
    getMLConfiguration({ commit, dispatch }, payload) {
      commit("setLoading", "Configuration");
      commit("setErrorObject", {
        name: "Configuration",
        errorObject: null,
      });
      GetConfiguration(
        payload.contractId,
        payload.versionId,
        payload.editionId,
        (response) => {
          commit("setConfiguration", JSON.parse(JSON.stringify(response)));

          dispatch("getContractConfiguration", {
            contractId: payload.contractId,
            versionId: payload.versionId,
            editionId: response.editionId,
          });

          commit("unsetLoading", "Configuration");
        },
        (error) => {
          this.errorObject = error;
          commit("unsetLoading", "Configuration");
          commit("setErrorObject", {
            name: "Configuration",
            errorObject: error,
          });
        },
      );
    },
    getInputGroupings({ commit }, payload) {
      commit("setLoading", "Groupings");
      commit("setErrorObject", {
        name: "Groupings",
        errorObject: null,
      });
      GetGroupings(
        payload.contractId,
        payload.versionId,
        payload.editionId,
        (response) => {
          commit("setGroupings", JSON.parse(JSON.stringify(response)));
          commit("unsetLoading", "Groupings");
        },
        (error) => {
          this.errorObject = error;
          commit("setErrorObject", {
            name: "Groupings",
            errorObject: error,
          });
          commit("unsetLoading", "Groupings");
        },
      );
    },
    getCriteria({ commit }, payload) {
      commit("setLoading", "Criteria");
      commit("setErrorObject", {
        name: "Criteria",
        errorObject: null,
      });
      GetCriteria(
        payload.contractId,
        payload.versionId,
        payload.editionId,
        (response) => {
          var items = response;

          items.map((item) => {
            if (!item.range) {
              item.range = {
                id: 0,
                criteriaId: 0,
                from: "",
                to: "",
              };
            }
          });

          commit("setCriteria", JSON.parse(JSON.stringify(items)));
          commit("unsetLoading", "Criteria");
        },
        (error) => {
          commit("unsetLoading", "Criteria");
          commit("setErrorObject", {
            name: "Criteria",
            errorObject: error,
          });
        },
      );
    },
    getVariables({ commit }, payload) {
      commit("setLoading", "Variables");
      commit("setErrorObject", {
        name: "Variables",
        errorObject: null,
      });
      GetAllVariables(
        payload.contractId,
        payload.versionId,
        payload.editionId,
        (response) => {
          commit("setVariables", JSON.parse(JSON.stringify(response)));
          commit("unsetLoading", "Variables");
        },
        (error) => {
          commit("setErrorObject", {
            name: "Variables",
            errorObject: error,
          });
          commit("unsetLoading", "Variables");
        },
      );
    },
    getStructure({ commit }, payload) {
      commit("setLoading", "Structure");
      commit("setErrorObject", {
        name: "Structure",
        errorObject: null,
      });

      GetStructure(
        payload.contractId,
        payload.versionId,
        payload.editionId,
        (response) => {
          commit("setStructure", response);
          commit(
            "setStructureFlat",
            getFlatStructure(JSON.parse(JSON.stringify(response))),
          );
          commit("unsetLoading", "Structure");
        },
        (error) => {
          commit("setErrorObject", {
            name: "Structure",
            errorObject: error,
          });
          commit("unsetLoading", "Structure");
        },
      );
    },
    getAllCities({ commit }) {
      commit("setLoading", "Cities");
      commit("setErrorObject", {
        name: "Cities",
        errorObject: null,
      });

      GetAllCities(
        (response) => {
          commit("setCities", JSON.parse(JSON.stringify(response)));
          commit("unsetLoading", "Cities");
        },
        (error) => {
          this.errorObject = error;
          commit("unsetLoading", "Cities");
          commit("setErrorObject", {
            name: "Cities",
            errorObject: error,
          });
        },
      );
    },
    getAllValidEditionLocations({ commit }, payload) {
      commit("setLoading", "ValidEditionLocations");
      commit("setErrorObject", {
        name: "ValidEditionLocations",
        errorObject: null,
      });

      GetCitiesVNext(
        payload.contractId,
        payload.versionId,
        payload.editionId,
        (response) => {
          if (response) {
            commit("setValidEditionLocations", response);
          }
        },
        (error) => {
          this.errorObject = error;
          commit("unsetLoading", "ValidEditionLocations");
          commit("setErrorObject", {
            name: "ValidEditionLocations",
            errorObject: error,
          });
        },
      );
    },
    getContractConfiguration({ commit }, payload) {
      GetSinlgeEdition(
        payload.contractId,
        payload.versionId,
        payload.editionId,
        (response) => {
          commit("setContractConfigurationCanUserEdit", response.stateId === 1);
        },
        (error) => {
          console.error(error);
        },
      );
    },
  },
  mutations: {
    setLoading(state, data) {
      if (!state.mindestLohnKonfiguration.isLoading.includes(data)) {
        state.mindestLohnKonfiguration.isLoading.push(data);
      }
    },
    unsetLoading(state, data) {
      if (state.mindestLohnKonfiguration.isLoading.includes(data)) {
        var index = state.mindestLohnKonfiguration.isLoading.indexOf(data);

        state.mindestLohnKonfiguration.isLoading.splice(index, 1);
      }
    },
    setTemplates(state, data) {
      state.mindestLohnKonfiguration.Templates = data;
    },
    setTenants(state, data) {
      state.mindestLohnKonfiguration.Tenants = data;
    },
    setErrorObject(state, data) {
      state.errorObjects[data.name] = data.errorObject;
    },
    setAdminCurrentContractTranslatedLanguages(state, data) {
      state.adminCurrentContract.TranslatedLanguages = data;
    },
    setAdminCurrentContractContractLanguage(state, data) {
      state.adminCurrentContract.ContractLanguage = data;
    },
    setAdminCurrentContractShortName(state, data) {
      state.adminCurrentContract.ShortName = data;
    },
    setAdminCurrentContractVersion(state, data) {
      state.adminCurrentContract.Version = data;
    },
    setAdminCurrentContractVersionId(state, data) {
      state.adminCurrentContract.VersionId = data;
    },
    setAdminCurrentVersionData(state, data) {
      state.adminCurrentContract.VersionData = data;
    },
    setAdminCurrentContractContractNumber(state, data) {
      state.adminCurrentContract.ContractNumber = data;
    },
    setAdminCurrentEditions(state, data) {
      state.adminCurrentContract.Editions = data;
    },
    setBasicContractInformation(state, data) {
      state.mindestLohnKonfiguration.BasicContractInformation = data;
    },
    setConfiguration(state, data) {
      state.mindestLohnKonfiguration.Configuration = data;
    },
    setCantons(state, data) {
      state.mindestLohnKonfiguration.Cantons = data;
    },
    setValidEditionLocations(state, data) {
      state.mindestLohnKonfiguration.ValidEditionLocations = data;
    },
    setCities(state, data) {
      state.mindestLohnKonfiguration.Cities = data;
    },
    setStructure(state, data) {
      state.mindestLohnKonfiguration.Structure = data;
    },
    setStructureFlat(state, data) {
      state.mindestLohnKonfiguration.StructureFlat = data;
    },
    setCriteria(state, data) {
      state.mindestLohnKonfiguration.Criteria = data;
    },
    setGroupings(state, data) {
      state.mindestLohnKonfiguration.Groupings = data;
    },
    setVariables(state, data) {
      state.mindestLohnKonfiguration.Variables = data;
    },
    setStates(state, data) {
      state.mindestLohnKonfiguration.States = data;
    },
    setAggregatedStates(state, data) {
      state.mindestLohnKonfiguration.AggregatedStates = data;
    },
    setContractsToCompare(state, data) {
      state.contractsToCompare = data;
    },
    setContractConfigurationCanUserEdit(state, data) {
      state.contractConfiguration.canUserEdit = data;
    },
  },
});
